/**
 * مجموعة حكم وأقوال جميلة عن الزواج وحسن العشرة
 * تُستخدم في صفحات الترحيب والتشجيع
 */

export const MARRIAGE_QUOTES = [
  {
    text: "وَمِنْ آيَاتِهِ أَنْ خَلَقَ لَكُم مِّنْ أَنفُسِكُمْ أَزْوَاجًا لِّتَسْكُنُوا إِلَيْهَا وَجَعَلَ بَيْنَكُم مَّوَدَّةً وَرَحْمَةً",
    source: "سورة الروم - 21"
  },
  {
    text: "خيركم خيركم لأهله، وأنا خيركم لأهلي",
    source: "رسول الله ﷺ"
  },
  {
    text: "ما كان الرفق في شيء إلا زانه، ولا نُزع من شيء إلا شانه",
    source: "رسول الله ﷺ"
  },
  {
    text: "تخيّروا لنطفكم، وانكحوا الأكفاء، وأنكحوا إليهم",
    source: "رسول الله ﷺ"
  },
  {
    text: "إذا أتاكم من ترضون دينه وخلقه فأنكحوه، إلا تفعلوا تكن فتنة في الأرض وفساد عريض",
    source: "رسول الله ﷺ"
  },
  {
    text: "تنكح المرأة لأربع: لمالها ولحسبها ولجمالها ولدينها، فاظفر بذات الدين تربت يداك",
    source: "رسول الله ﷺ"
  },
  {
    text: "استوصوا بالنساء خيراً",
    source: "رسول الله ﷺ"
  },
  {
    text: "الدنيا متاع، وخير متاعها المرأة الصالحة",
    source: "رسول الله ﷺ"
  },
  {
    text: "لا يفرك مؤمن مؤمنة، إن كره منها خلقاً رضي منها آخر",
    source: "رسول الله ﷺ"
  },
  {
    text: "إن من أكمل المؤمنين إيماناً أحسنهم خلقاً وألطفهم بأهله",
    source: "رسول الله ﷺ"
  },
  {
    text: "الزواج نصف الدين، فليتقِ الله العبد في النصف الباقي",
    source: "حكمة"
  },
  {
    text: "الحب الحقيقي يكبر مع السنين، أما الإعجاب فيذبل سريعاً",
    source: "حكمة"
  },
  {
    text: "خير البيوت بيت فيه يتيم يُكرم، وخير الأزواج من رحم وأكرم",
    source: "حكمة"
  },
  {
    text: "لا تكن صعب المراس، فإن الحياة قصيرة والابتسامة لا تكلف شيئاً",
    source: "حكمة"
  },
  {
    text: "البيت الذي يُذكر فيه الله مثل البيت الحي، والذي لا يُذكر فيه الله مثل البيت الميت",
    source: "رسول الله ﷺ"
  },
  {
    text: "ما أكرم النساء إلا كريم، وما أهانهن إلا لئيم",
    source: "رسول الله ﷺ"
  },
  {
    text: "اجتنبوا السبع الموبقات، وأكرموا أهليكم، فإن أكرمكم عند الله أتقاكم",
    source: "أثر"
  },
  {
    text: "أعقل الناس أعذرهم للناس، خاصة في بيته",
    source: "حكمة"
  },
  {
    text: "كن لزوجك سكناً كما جعلك الله، فالسكن أعظم نعمة بعد الإيمان",
    source: "حكمة"
  },
  {
    text: "ليس الرجل من يُطعم زوجته، بل من يستر ضعفها ويُعلي شأنها",
    source: "حكمة"
  },
  {
    text: "إن الله جميل يحب الجمال، فجمّلوا أخلاقكم قبل وجوهكم",
    source: "حكمة"
  },
  {
    text: "العفو زينة الأقوياء، خاصة بين الزوجين",
    source: "حكمة"
  },
  {
    text: "الكلمة الطيبة صدقة، فلا تبخل بها على من تحب",
    source: "أثر"
  },
  {
    text: "اللهم بارك لنا في أزواجنا وذرياتنا، واجعلنا للمتقين إماماً",
    source: "دعاء قرآني"
  },
  {
    text: "احفظ ودّك مع أهلك يُحفظ لك في كل مكان",
    source: "حكمة"
  }
];

/**
 * يرجع حكمة عشوائية كل مرة
 */
export const getRandomQuote = () => {
  return MARRIAGE_QUOTES[Math.floor(Math.random() * MARRIAGE_QUOTES.length)];
};

/**
 * يرجع حكمة يومية ثابتة (تتغير كل يوم لكن تبقى ثابتة خلال اليوم)
 */
export const getDailyQuote = () => {
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 86400000);
  return MARRIAGE_QUOTES[dayOfYear % MARRIAGE_QUOTES.length];
};
